module.exports = __webpack_public_path__ + "img/tooltip_10-vallone-litho-finish-fokos-roccia.22fad061.jpg";